import React from "react";
import { Route } from "react-router-dom";
import Account from "./Account/routes";
import AccountSetting from "./AccountSetting/routes";
import Break from "./Break/routes";
import CSAT from "./CSAT/routes";
import CallInternalActions from "./CallInternalActions/routes";
import CarrierRate from "./CarrierRate/routes";
import Config from "./Config/routes";
import Contact from "./Contact/routes";
import ContactDetail from "./ContactDetails/routes";
import ContactList from "./ContactList/routes";
import ContactListPrivate from "./ContactListPrivate/routes";
import ContactPrivateInfo from "./ContactPrivateInfo/routes";
import Country from "./Country/routes";
import DNC from "./DNC/routes";
import Despose from "./Despose/routes";
import EmailProvider from "./EmailProvider/routes";
import EmailTemplete from "./EmailTemplete/routes";
import Flow from "./Flow/routes";
import FlowList from "./FlowList/routes";
import Holiday from "./Holiday/routes";
import HolidayGroup from "./HolidayGroup/routes";
import ImportExport from "./ImportExport/routes";
import Integrations from "./Integrations/routes";
import Logs from "./Logs/routes";
import NlpAgent from "./NlpAgent/routes";
import NlpIntenet from "./NlpIntenet/routes";
import Permissions from "./Permissions/routes";
import PhoneCalls from "./PhoneCalls/routes";
import Phonenumbers from "./Phonenumbers/routes";
import Queue from "./Queue/routes";
import RcsProvider from "./RcsProvider/routes";
import Region from "./Region/routes";
import SIP from "./SIP/routes";
import SIPExtensions from "./SIPExtensions/routes";
import Skills from "./Skills/routes";
import SmppProvider from "./SmppProvider/routes";
import SmsProvider from "./SmsProvider/routes";
import SmsSender from "./SmsSender/routes";
import SmsTemplete from "./SmsTemplete/routes";
import Sounds from "./Sounds/routes";
import StickyAgent from "./StickyAgent/routes";
import Tag from "./Tag/routes";
import User from "./User/routes";
import UserMapSkill from "./UserMapSkill/routes";
import WhatsAppProvider from "./WhatsAppProvider/routes";
import WhatsAppSender from "./WhatsAppSender/routes";
import WhatsappTemplate from "./WhatsappTemplate/routes";
import MainRoutes from "./main/routes";
import Providers from "./providers/routes";
import CannedMessagesRoutes from "./CannedMessages/routes";
import VoiceProvider from "./VoiceProvider/routes";
import ModelProvider from "./ModelProvider/routes";
import TranscriberProvider from "./TranscriberProvider/routes";
import KnowledgeBaseRoutes from "./KnowledgeBase/routes";
import KnowledgeBaseDoc from "./KnowledgeBaseDoc/routes";
import TTSBillingProvider from "./TTSBillingProvider/routes";
import GuardrailsRoutes from "./Guardrails/routes";
import HelpCenterRoutes from "./HelpCenter/routes";
import HelpCenterCollectionsRoutes from "./HelpCenterCollections/routes";
import HelpCenterFolderRoutes from "./HelpCenterFolder/routes";
import HelpCenterFileRoutes from "./HelpCenterFile/routes";
import InboundBlock from "./InboundBlock/routes";
import MCPServer from "./MCPServer/routes";

const routes = () => [
  <Account key="Account" />,
  <AccountSetting key="AccountSetting" />,
  <Break key="Break" />,
  <CSAT key="CSAT" />,
  <CallInternalActions key="CallInternalActions" />,
  <CarrierRate key="CarrierRate" />,
  <Config key="Config" />,
  <Contact key="Contact" />,
  <ContactDetail key="ContactDetails" />,
  <ContactList key="ContactList" />,
  <ContactListPrivate key="ContactListPrivate" />,
  <ContactPrivateInfo key="ContactPrivateInfo" />,
  <Country key="Country" />,
  <DNC key="DNC" />,
  <Despose key="Despose" />,
  <EmailProvider key="EmailProvider" />,
  <EmailTemplete key="EmailTemplete" />,
  <Flow key="Flow" />,
  <FlowList key="FlowList" />,
  <Holiday key="Holiday" />,
  <HolidayGroup key="HolidayGroup" />,
  <ImportExport key="ImportExport" />,
  <Integrations key="Integrations" />,
  <Logs key="Logs" />,
  <MainRoutes key="MainRoutes" />,
  <NlpAgent key="NlpAgent" />,
  <NlpIntenet key="NlpIntenet" />,
  <Permissions key="Permissions" />,
  <PhoneCalls key="PhoneCalls" />,
  <Phonenumbers key="Phonenumbers" />,
  <Providers key="Providers" />,
  <Queue key="Queue" />,
  <RcsProvider key="RcsProvider" />,
  // <Region key='Region' />,
  <VoiceProvider key="voice-provider" />,
  <ModelProvider key="model-provider" />,
  <TranscriberProvider key="transcriber-provider" />,
  <SIP key="SIP" />,
  <SIPExtensions key="SIPExtensions" />,
  <Skills key="Skills" />,
  <SmppProvider key="SmppProvider" />,
  <SmsProvider key="SmsProvider" />,
  <SmsSender key="SmsSender" />,
  <SmsTemplete key="SmsTemplete" />,
  <Sounds key="Sounds" />,
  <StickyAgent key="StickyAgent" />,
  <Tag key="Tag" />,
  <User key="User" />,
  <UserMapSkill key="UserMapSkill" />,
  <WhatsAppProvider key="WhatsAppProvider" />,
  <WhatsAppSender key="WhatsAppSender" />,
  <WhatsappTemplate key="WhatsappTemplate" />,
  <CannedMessagesRoutes key="CannedMessages" />,
  <KnowledgeBaseRoutes key="KnowledgeBase" />,
  <KnowledgeBaseDoc key="KnowledgeBaseDoc" />,
  <TTSBillingProvider key="TTSBillingProvider" />,
  <GuardrailsRoutes key="GuardrailsRoutes" />,
  <HelpCenterRoutes key="HelpCenterRoutes" />,
  <HelpCenterCollectionsRoutes key="HelpCenterCollections" />,
  <HelpCenterFolderRoutes key="HelpCenterFolder" />,
  <HelpCenterFileRoutes key="HelpCenterFile" />,
  <InboundBlock key="InboundBlock" />,
  <MCPServer key="MCPServer" />,
];

const settingsRoute = () => <Route component={routes} />;

export default settingsRoute;



// WEBPACK FOOTER //
// src/modules/screens/settings/routes.js